import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turnos"
export default class extends Controller {
  connect() {
  }
}
